export default __webpack_public_path__ + "static/media/Ch3c.9a6e6ba8.gif";